import React, { useState } from 'react';
import { Popover } from 'antd';
import { FormattedMessage } from 'react-intl';
import s from './index.module.scss';

/**
 * 咨询按钮组件
 * @param {string} locale - 当前语言环境
 */
const InquireBtn = ({locale}) => {
  const [open, setOpen] = useState(false);
  // 判断是否为中文环境
  const isEnglish = locale === 'en-US';

  // 中文环境的内容
  const chineseContent = (
    <div className={s.popoverContent}>
      <div style={{ display: 'flex', marginBottom: '10px' }}>
        <i className={s.tel} />
        <span className={s.phone}>(010) 8476 6899</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <i className={s.email} />
        <a
          href="mailto:bd@qingping.co"
          className={s.emailLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          bd@qingping.co
        </a>
      </div>

    </div>
  );

  // 英文环境的内容（仅显示邮箱）
  const englishContent = (
    <div className={s.popoverContent}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <i className={s.email} />
        <a
          href="mailto:bd@qingping.co"
          className={s.emailLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          bd@qingping.co
        </a>
      </div>
    </div>
  );

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const content = isEnglish ? englishContent : chineseContent;

  return (
    <Popover
      content={content}
      trigger={['click', 'hover']}
      open={open}
      onOpenChange={handleOpenChange}
      placement="bottomLeft"
      overlayClassName={s.inquirePopover}
    >
      <div className={s.inquireBtn}>
        <span className={s.btnText}>
          <FormattedMessage id="inquire_btn" />
        </span>
      </div>
    </Popover>
  );
};

export default InquireBtn;

